module.exports = __webpack_public_path__ + "static/media/1 06 nysgjerrig.d46fd35e.mp3";